export const ROLE_ADMIN = "admin";
export const ROLE_REVIEWER = "reviewer";
export const ROLE_VIEWER = "viewer";

export const ROLE_DISTRICT_EDO_LEGACY = "district_EDO";
export const ROLE_ENVIRONMENTAL_DISTRICT_OFFICER = "Environmental District Officer";

export const DISTRICT_EDO_ROLES = [
  ROLE_ENVIRONMENTAL_DISTRICT_OFFICER,
  ROLE_DISTRICT_EDO_LEGACY,
];

export const normalizeRole = (role) =>
  role === ROLE_DISTRICT_EDO_LEGACY
    ? ROLE_ENVIRONMENTAL_DISTRICT_OFFICER
    : role;
